import React, { useMemo } from "react";
import Toast from "../components/Toast.js";

const formatDate = (epochTimeInNs) => {
  const dateObj = new Date(epochTimeInNs / 1000000);
  const year = dateObj.getFullYear().toString().slice(-2);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const dateString = `${day}/${month}/${year}`;
  return dateString;
};
const formatTime = (epochTimeInNs) => {
  const dateObj = new Date(epochTimeInNs / 1000000);
  let hour = dateObj.getHours().toString();
  let minute = dateObj.getMinutes().toString().padStart(2, "0");
  let amPm = "AM";
  if (hour >= 12) {
    hour -= 12;
    amPm = "PM";
  }
  if (hour === 0) {
    hour = 12;
  }
  const timeString = `${hour}:${minute} ${amPm}`;
  return timeString;
};
const AlertItem = ({ item }) => {
  const time = useMemo(() => formatTime(item.timestamp), [item.timestamp]);
  const date = useMemo(() => formatDate(item.timestamp), [item.timestamp]);

  if (typeof item.messages[0] === 'object' && !Array.isArray(item.messages[0])) {

    const arr = item.messages.map(dict =>
      Object.keys(dict)
        .filter(key => dict[key].message)
        .map(key => `${key}: ${dict[key].message}`).flat()
    );
    item.messages = arr[0];
  }

  const alertWarningSvg = (
    <svg
      width="42"
      height="38"
      viewBox="0 0 42 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.008 29.2056H19.999C19.709 29.2056 19.474 29.4407 19.474 29.7306V31.7396C19.474 32.0296 19.709 32.2646 19.999 32.2646H22.008C22.2979 32.2646 22.533 32.0296 22.533 31.7396V29.7306C22.533 29.4407 22.2979 29.2056 22.008 29.2056Z"
        fill="#F1C21B"
      />
      <path
        d="M19.4781 19.6156V13.1266C19.4781 13.0053 19.5258 12.8888 19.6109 12.8024C19.6961 12.7159 19.8118 12.6664 19.9331 12.6646H22.0751C22.1964 12.6664 22.3121 12.7159 22.3973 12.8024C22.4824 12.8888 22.5301 13.0053 22.5301 13.1266V19.6156L21.9701 26.7696C21.9613 26.886 21.9087 26.9947 21.823 27.0739C21.7373 27.1531 21.6248 27.1969 21.5081 27.1966H20.5071C20.3911 27.1968 20.2794 27.1528 20.1949 27.0734C20.1103 26.994 20.0592 26.8854 20.0521 26.7696L19.4781 19.6156Z"
        fill="#F1C21B"
      />
      <path
        d="M40.9687 37.8996H1.03128C0.849684 37.8985 0.67156 37.8482 0.514706 37.7539C0.357852 37.6595 0.227762 37.5244 0.137439 37.3619C0.047117 37.1995 -0.00027472 37.0155 1.19795e-06 36.8282C0.000277116 36.641 0.0482113 36.4571 0.139012 36.2949L20.1008 0.635688C20.1918 0.472739 20.3228 0.33739 20.4807 0.243276C20.6385 0.149162 20.8176 0.0996094 21 0.0996094C21.1823 0.0996094 21.3615 0.149162 21.5193 0.243276C21.6772 0.33739 21.8082 0.472739 21.8992 0.635688L41.861 36.2949C41.9518 36.4571 41.9997 36.641 42 36.8282C42.0003 37.0155 41.9529 37.1995 41.8626 37.3619C41.7722 37.5244 41.6421 37.6595 41.4853 37.7539C41.3284 37.8482 41.1503 37.8985 40.9687 37.8996ZM4.02624 35.0469H37.9738L21 4.7365L4.02624 35.0469Z"
        fill="#F1C21B"
      />
    </svg>
  );

  return (
    <div className="flex w-[1536px] bg-light-7 border-l-4 rounded-[4px] p-[29px] mt-[27px] border-dark-yellow ">
      <div className="flex justify-between w-full">
        {/* div for icon and msg */}
        <div className="flex">
          <div className="text-light-1">{alertWarningSvg}</div>
          <div className="text-light-1 flex flex-col pl-[22px]">
            {" "}
            {item.messages.map((msg) =>
              typeof msg === "string" && (
                <div className="text-light-3 text-md font-sans" key={msg}>
                  {msg}
                </div>
            ))}
          </div>
        </div>
        {/* div for date and time */}
        <div className="flex flex-col items-end text-light-3 text-md">
          <span>{time}</span>
          <span>{date}</span>
        </div>
      </div>
    </div>
  );
};
const AlertView = ({ toastMessages, alertMessages }) => {
  return (
    <div className="w-full h-screen ">
      {toastMessages.length === 0 ? null : <Toast messages={toastMessages} />}
      <div className="text-light-1 text-xl font-sans pt-[100px] pl-[48px]">
        Alerts
      </div>
      <div className="pt-[78px] pl-[51px] font-sans text-sm text-light-2">
        Active ({alertMessages.length})
      </div>{" "}
      <div className="flex flex-col h-[75vh] pl-[51px] overflow-y-scroll">
        {" "}
        {alertMessages.map((item, index) =>
          <AlertItem key={index} item={item} />
        )}
      </div>
    </div>
  );
};
export default AlertView;
